export default __webpack_public_path__ + "static/media/Bluewater1.a2830937.webp";